import { memo } from 'react';
import { Picture } from '@ui';
import {
  appBannerNewPhone,
  appBannerNewPhoneMobile,
  appleGreyOnWhite,
  googleGreyOnWhite,
  huaweiGreyOnWhite,
  rustoreGreyOnWhite
} from '@images';
import {
  APP_STORE,
  GOOGLE_PLAY,
  HUAWEI_STORE,
  RUSTORE
} from '@constants/appLinks';
import useClipboard from '@customHooks/useClipboard';
import QRCodeComponent from '@components/QRCode';

const AppBannerNew = () => {
  const { copyPromocode } = useClipboard({ text: 'NEW500' });
  return (
    <div className='bg-[#CDEDFF] p-8 rounded-3xl relative overflow-hidden allMd:p-4 allMd:rounded-2xl allMd:h-[200px]'>
      <div className='relative z-10 w-[306px] allMd:w-auto'>
        <div className='mb-5 allMd:mb-2.5'>
          <div className='mb-3 text-3xl font-medium leading-tight allMd:text-xl allMd:leading-6'>
            Дарим 500 ₽ <span className='block' /> на первый заказ
          </div>
          <div className='text-[22px] leading-7 allMd:text-sm'>
            из приложения от 3000 ₽
          </div>
        </div>
        <div className='flex items-center gap-[26px] allMd:contents'>
          <div className='allMd:contents'>
            <div className='flex items-center h-8 mb-5 allMd:h-7 allMd:mb-5'>
              <div className='h-full flex items-center pl-2 pr-3 rounded-lg border-2 border-solid border-white leading-[22px]'>
                Промокод
              </div>
              <button
                onClick={copyPromocode}
                className='md:text-base h-full flex items-center bg-[#E30447] relative -left-2 rounded-lg  text-white text-xl  px-2 leading-none'
              >
                NEW500
              </button>
            </div>
            <div className='flex items-center gap-2 allMd:gap-1.5'>
              <a href={APP_STORE} target='_blank' rel='noreferrer'>
                <Picture
                  icon={appleGreyOnWhite}
                  pictureClassName='[&>img]:allMd:w-[30px] [&>img]:allMd:h-[30px]'
                  width='40'
                  height='40'
                  alt='appStore'
                />
              </a>
              <a href={GOOGLE_PLAY} target='_blank' rel='noreferrer'>
                <Picture
                  icon={googleGreyOnWhite}
                  pictureClassName='[&>img]:allMd:w-[30px] [&>img]:allMd:h-[30px]'
                  width='40'
                  height='40'
                  alt='google play'
                />
              </a>
              <a href={HUAWEI_STORE} target='_blank' rel='noreferrer'>
                <Picture
                  icon={huaweiGreyOnWhite}
                  pictureClassName='[&>img]:allMd:w-[30px] [&>img]:allMd:h-[30px]'
                  width='40'
                  height='40'
                  alt='google play'
                />
              </a>
              <a href={RUSTORE} target='_blank' rel='noreferrer'>
                <Picture
                  icon={rustoreGreyOnWhite}
                  pictureClassName='[&>img]:allMd:w-[30px] [&>img]:allMd:h-[30px]'
                  width='40'
                  height='40'
                  alt='rustore'
                />
              </a>
            </div>
          </div>
          <div className='flex h-[92px] w-[92px] flex-shrink-0 items-center justify-center rounded-[12px] bg-white allMd:hidden'>
            <QRCodeComponent
              size={76}
              includeMargin={false}
              className='!rounded-none [&_.qr-code-wrapper]:!rounded-none'
            />
          </div>
        </div>
      </div>
      <Picture
        icon={appBannerNewPhone}
        width={318}
        height={285}
        className='absolute bottom-0 right-5 allMd:hidden'
      />
      <Picture
        icon={appBannerNewPhoneMobile}
        width={199}
        height={191}
        className='absolute bottom-0 hidden right-2 allMd:block'
      />
    </div>
  );
};

export default memo(AppBannerNew);
